import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("nb_cart") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("nb_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (note) => {
    setItems((prev) => {
      if (prev.find((i) => i.id === note.id)) {
        toast.info("Already in your cart");
        return prev;
      }
      toast.success("Added to cart");
      return [...prev, { id: note.id, title: note.title, price: note.price, subject: note.subject, seller_name: note.seller_name, has_cover: note.has_cover }];
    });
  };

  const removeItem = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
  const clearCart = () => setItems([]);
  const inCart = (id) => items.some((i) => i.id === id);
  const total = items.reduce((s, i) => s + i.price, 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, clearCart, inCart, total, count: items.length }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
